module.exports = __webpack_public_path__ + "static/media/chain-of-wounds.257e9062.png";